






























import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	components: {
		
	},
	props: ["confirmationText"],

	data() {
		return {

		};
	},

	created(){
		
	},

	methods: {
        hideModal() {
			this.$bvModal.hide("confirmation-modal");
		},

        confirm(){
            this.hideModal();
            this.$emit('confirmation-confirmed');
        },

        cancel(){
            this.hideModal();
            this.$emit('confirmation-cancelled');
        }

	}

});
